import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'
import { DELIVERABLE_SEND_FILE_URL } from 'src/views/Pages/Onboarding/flowConfig'
import globalConsts from '../../globalConsts'

import { ExternalLink } from 'src/components/Core/Styles/Link'
import Font from 'src/components/Core/Typography/Font/Font'
import InputFilesGroup from 'src/views/Forms/Components/InputFilesGroup/InputFilesGroup'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'
import { ConfigCompanyDetails } from '../../CorporateAccount/CompanyDetails/types'
import InputFilesPerType from 'src/views/Forms/Components/InputFilesPerType/InputFilesPerType'
import globalConfig from 'src/components/Organisms/Form/config'

export const dataProtectionLink = <ExternalLink href='https://www.sucdenfinancial.com/en/op/data-protection-and-privacy-policy' />
export const boardResolutionFormTemplate = <ExternalLink href='https://www.sucdenfinancial.com/media/p1oe301a/sfl-board-resolution-form.pdf' />

const SucdenAndHolderAgreementAndDocumentsText = (
  <Font key='sucdenAndHolderAgreementAndDocumentsText' ellipsis={false}>
    {/* @ts-ignore:next-line */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.DeclarationsForm.visualOnly.sucdenAndHolderAgreementAndDocumentsText'} />
  </Font>
)

const CertifiedCopyText = (
  <Font key='certifiedCopyText' ellipsis={false}>
    <Trans i18nKey={'onboarding.forms.CorporateAccount.DeclarationsForm.visualOnly.certifiedCopyText'} components={{requiredMark: <RequiredMark />}} />
  </Font>
)

const DetailsPersonCertifying = (
  <Font key='detailsPersonCertifying' ellipsis={false}>
    {t('onboarding.forms.CorporateAccount.DeclarationsForm.visualOnly.detailsPersonCertifying')}
  </Font>
)

const config = ({ countryTelephoneCodes }: ConfigCompanyDetails) => utils.injectTranslation({
  id: 'DeclarationsForm',
  path: 'onboarding.forms.CorporateAccount.DeclarationsForm.inputs',
  keysToRemove: ['visual', 'documentID'],
  content: [
    {
      componentType: 'grid',
      props: {
        marginBottom: '8px'
      },
      content: [
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'certifyAuthorisedSign',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            marginWrapper: '8px 0 0 0',
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'allStatmentsMadeCorrect',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'takeSucdenAdvise',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'dataProtectionPolicyConfirmation',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {dataProtectionLink, requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'informationAcknowledgement',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'agreeToBoundForProvisions',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: '',
          visualComponent: SucdenAndHolderAgreementAndDocumentsText
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_COIDOCUMENT,
            required: true,
          },
          custom: props => InputFilesGroup({
            margin: '16px 0 0 0',
            inputMargin: '8px 0 24px 0',
            groupLabel:
              <Trans i18nKey={'onboarding.forms.CorporateAccount.DeclarationsForm.files.certificateIncorporation.groupLabel'} />,
            inputLabel: t('onboarding.forms.CorporateAccount.DeclarationsForm.files.certificateIncorporation.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: DELIVERABLE_SEND_FILE_URL
              }
            },
            step: '14',
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_COIDOCUMENT,
            ...props
          }),
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_MOADOCUMENT,
            required: true,
          },
          custom: props => InputFilesGroup({
            inputMargin: '8px 0 24px 0',
            groupLabel: <Trans i18nKey={'onboarding.forms.CorporateAccount.DeclarationsForm.files.memorandumAndArticles.groupLabel'} />,
            inputLabel: t('onboarding.forms.CorporateAccount.DeclarationsForm.files.memorandumAndArticles.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: DELIVERABLE_SEND_FILE_URL
              }
            },
            step: '14',
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_MOADOCUMENT,
            ...props
          }),
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_COSDOCUMENT,
            required: true,
          },
          custom: props => InputFilesGroup({
            inputMargin: '8px 0 24px 0',
            groupLabel: <Trans i18nKey={'onboarding.forms.CorporateAccount.DeclarationsForm.files.ownershipStructure.groupLabel'} />,
            inputLabel: t('onboarding.forms.CorporateAccount.DeclarationsForm.files.ownershipStructure.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: DELIVERABLE_SEND_FILE_URL
              }
            },
            step: '14',
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_COSDOCUMENT,
            ...props
          }),
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_CDRDOCUMENT,
            required: true,
          },
          custom: props => InputFilesGroup({
            inputMargin: '8px 0 24px 0',
            groupLabel: <Trans i18nKey={'onboarding.forms.CorporateAccount.DeclarationsForm.files.directorsRegister.groupLabel'} />,
            inputLabel: t('onboarding.forms.CorporateAccount.DeclarationsForm.files.directorsRegister.inputLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: DELIVERABLE_SEND_FILE_URL
              }
            },
            step: '14',
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_CDRDOCUMENT,
            ...props
          }),
        },
        {
          componentType: 'input',
          props: {
            name: 'directorUboProofs',
            required: true,
          },
          // @ts-ignore:next-line
          custom: props => InputFilesPerType({
            name: 'directorUboProofs',
            step: '14',
            groupLabel: 'onboarding.forms.CorporateAccount.DeclarationsForm.files.passportAndCurrentBill.groupLabel',
            formType: 'Deliverable',
            ...props
          }),
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_BRDOCUMENT,
            required: true,
          },
          custom: props => InputFilesGroup({
            inputMargin: '8px 0 24px 0',
            inputLabel: t('onboarding.forms.CorporateAccount.DeclarationsForm.files.boardResolution.inputLabel'),
            groupLabel: <Trans i18nKey={'onboarding.forms.CorporateAccount.DeclarationsForm.files.boardResolution.groupLabel'} components={{ boardResolutionFormTemplate }}/>,
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: DELIVERABLE_SEND_FILE_URL
              }
            },
            step: '14',
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_BRDOCUMENT,
            margin: '24px 0 0 0',
            ...props
          }),
        },
        {
          componentType: 'input',
          props: {
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_RACDOCUMENT,
            required: true,
          },
          custom: props => InputFilesGroup({
            inputMargin: '8px 0 24px 0',
            inputLabel: t('onboarding.forms.CorporateAccount.DeclarationsForm.files.reportsAndAccounts.inputLabel'),
            groupLabel: t('onboarding.forms.CorporateAccount.DeclarationsForm.files.reportsAndAccounts.groupLabel'),
            singleFileInput: true,
            fetchOptions: {
              requestConfig: {
                url: DELIVERABLE_SEND_FILE_URL
              }
            },
            step: '14',
            name: globalConsts.INPUT_FILES_CORPORATE_DECLARATIONS_RACDOCUMENT,
            ...props
          }),
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        rowGap: '20px',
        padding: '20px 20px 0 20px',
        boxSizing: 'border-box',
        borderRadius: '3px 3px 0 0',
        backgroundColor: 'neutral-1'
      },
      content: [
        {
          componentType: '',
          visualComponent: CertifiedCopyText
        },
        {
          componentType: '',
          visualComponent: DetailsPersonCertifying
        }
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
        padding: '0 20px 0 20px',
        boxSizing: 'border-box',
        backgroundColor: 'neutral-1'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'firstName',
            maxlength: 100,
          }
        },
        {
          componentType: 'input',
          submitValidation: 'email',
          props: {
            name: 'emailAddress',
            maxlength: 100,
          }
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        padding: '0 20px 0 20px',
        boxSizing: 'border-box',
        borderRadius: '0 0 3px 3px',
        backgroundColor: 'neutral-1'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'companyName',
            maxlength: 100,
          }
        },
        {
          componentType: 'input',
          props: {
            name: 'occupation',
            maxlength: 100,
          }
        },
        {
          componentType: 'input',
          props: {
            name: 'certifiedTelephCountryIndex',
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countryTelephoneCodes,
            name: 'certifiedTelephCountryIndex',
            label: 'onboarding.forms.CorporateAccount.DeclarationsForm.inputs.certifiedTelephCountryIndex.label',
            placeholder: 'onboarding.forms.CorporateAccount.DeclarationsForm.inputs.certifiedTelephCountryIndex.placeholder',
            filter: true,
            ...props
          })
        },
        {
          componentType: 'input',
          transformType: 'transformValidationTelephoneCodePlusNumber',
          props: {
            name: 'validationCertifiedTelephCountryIndex',
            show: false,
          },
        },
        {
          componentType: 'input',
          transformType: 'transformTelephoneNumber',
          submitValidation: 'telephoneWithMinimum',
          props: {
            name: 'telephone',
            pattern: globalConfig?.regex?.telephoneNoPlusSignal100,
          }
        },
      ]
    }
  ],
})

export default config
